import { render, staticRenderFns } from "./Notreview.vue?vue&type=template&id=4c442bb5&scoped=true&"
import script from "./Notreview.vue?vue&type=script&lang=js&"
export * from "./Notreview.vue?vue&type=script&lang=js&"
import style0 from "./Notreview.vue?vue&type=style&index=0&id=4c442bb5&scoped=true&lang=css&"
import style1 from "./Notreview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c442bb5",
  null
  
)

export default component.exports